export default __webpack_public_path__ + "static/media/visibility_off.5fa65a5e.svg";